import React, { Component } from "react";
import { Row, Col, InputGroup, DropdownButton, FormControl, Dropdown } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';

class QuestionOptInputNumber extends Component {
    constructor(props) {
        super(props);

        // {
        //     "data": "value",
        //      onChange": func
        // }
    }

    // onSelect=(e) => {
    //     console.log(e);
    //     if (e!=this.props.o_type) {
    //         let tmp=parseInt(e);
    //         if (isNaN(tmp)==false) {
    //             console.log(this.props.onChange);
    //             this.props.onChange(e);
    //         }
    //     }
    // }

    render() {
        const data=this.props.data;
        // var opts=Object.keys(E_OPT_TYPE).map(function (key) {
        //     return <Dropdown.Item key={key} eventKey={key}>{E_OPT_TYPE[key]}</Dropdown.Item>
        // });
        return (
            <input type="text" className="w-100 underline" value={data} onChange={this.props.onChange} />
        );
    }
}

export default QuestionOptInputNumber;